/**
 * index: 質問
 * 0: チュールなどの柔らかい素材感が好き？
 * 1: 王道なデザインが好き？
 * 2: 良いものであれば価格を気にせずに選ぶ方だ
 * 3: ボリュームのあるドレスが好き？
 * 4: ドレスは海外の人気ブランドがいい？
 * 5: 大人っぽい雰囲気のドレスが好き？
 * 6: 豪華で華やかなドレスが好き？
 * 7: ドレスは他の人と被りたくない？
 * 8: ロイヤルな雰囲気のドレスが好き？
 *
 * index: 診断結果
 * 0: キュートタイプ
 * 1: フェミニン系タイプ
 * 2: カジュアル系タイプ
 * 3: モード系タイプ
 * 4: リュクス系タイプ
 * 5: 大人かわいいタイプ
 */
import Q1 from 'pages/questions/Q1'
import Q2 from 'pages/questions/Q2'
import Q3 from 'pages/questions/Q3'
import Q4 from 'pages/questions/Q4'
import Q5 from 'pages/questions/Q5'
import Q6 from 'pages/questions/Q6'
import Q7 from 'pages/questions/Q7'
import Q8 from 'pages/questions/Q8'
import Q9 from 'pages/questions/Q9'
import R1 from 'pages/results/R1'
import R2 from 'pages/results/R2'
import R3 from 'pages/results/R3'
import R4 from 'pages/results/R4'
import R5 from 'pages/results/R5'
import R6 from 'pages/results/R6'

const routes = {
  questions: [
    <Q1 />,
    <Q2 />,
    <Q3 />,
    <Q4 />,
    <Q5 />,
    <Q6 />,
    <Q7 />,
    <Q8 />,
    <Q9 />,
  ],
  results: [<R1 />, <R2 />, <R3 />, <R4 />, <R5 />, <R6 />],
}

export default routes
